import {
  Typography,
  Paper,
  Switches,
  CardHeader,
  IconAvatar,
  RemoveRedEyeOutlinedIcon,
} from '@occc-app/design-system';

type StayVisibleWhileInProgressProps = { name: string };

export const StayVisibleWhileInProgress = ({ name }: StayVisibleWhileInProgressProps) => (
  <Paper>
    <CardHeader
      title={<Typography variant='subtitle1'>Remain Visible While In Progress</Typography>}
      subheader={
        <Typography variant='body2' color='textSecondary'>
          Punchcard will stay visible to members until completion
        </Typography>
      }
      action={<Switches name={name} data={{}} />}
      avatar={<IconAvatar Icon={RemoveRedEyeOutlinedIcon} />}
      sx={{ py: 2, px: 3 }}
    />
  </Paper>
);
